import React from 'react'
import { node } from 'prop-types'
import {
  ThemeProvider as CreditasUiThemeProvider,
  standard,
  Global,
} from '@creditas-ui/react'
import { customReset } from './customReset'

const propTypes = {
  children: node,
}

const ThemeProvider = ({ children }) => (
  <CreditasUiThemeProvider theme={standard}>
    <Global styles={customReset} />
    {children}
  </CreditasUiThemeProvider>
)

ThemeProvider.propTypes = propTypes

export { ThemeProvider }
